import styled from '@emotion/styled'

interface LoaderCellProps {
  columnCount: number
}

export const LoaderCell = styled.td<LoaderCellProps>`
  grid-column: span ${({ columnCount }) => columnCount};
  text-align: center;
`

export const TableFooter = styled.tfoot`
  height: 10px;
  margin: -10px;
`
